import {h, render} from 'preact';
import Radio from "./Radio";

function Answers({items, onRadioChecked, disabled}) {
    const className = !!disabled ? 'oQuiz__Answers oQuiz__Answers--off' : 'oQuiz__Answers';
    return (
        <ul className={className}>
            {Array.isArray(items) &&
                items.map(({label, checked, correct, id}) => (
                    <li className="aQuizAnswer">
                        <Radio name="answer" onInput={onRadioChecked} correct={correct} checked={checked} label={label} id={id} disabled={disabled}/>
                    </li>
                ))
            }
        </ul>
    )
}

export default Answers
